import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpen, Wind, Package, FileText, Calendar, HelpCircle, Book } from 'lucide-react';
export function ProductPresentation() {
  const modules = [{
    icon: <BookOpen className="w-6 h-6 text-white" data-id="element-259" />,
    title: 'El Método MRS (Rampa de Salida)',
    desc: '3 pasos exactos',
    result: 'Transiciones suaves sin resistencia'
  }, {
    icon: <Wind className="w-6 h-6 text-white" data-id="element-260" />,
    title: 'Kit de Respiraciones Divertidas',
    desc: '3 técnicas por edad',
    result: 'Bajas el cortisol en menos de 3 minutos'
  }, {
    icon: <Package className="w-6 h-6 text-white" data-id="element-261" />,
    title: 'La Caja de Emergencia Post-Pantalla',
    desc: 'Qué poner y cómo usarla',
    result: 'El cerebro reconecta con el mundo real'
  }, {
    icon: <FileText className="w-6 h-6 text-white" data-id="element-262" />,
    title: 'El Contrato Visual de Paz',
    desc: 'Plantilla lista para imprimir',
    result: 'Los niños cooperan porque participaron'
  }, {
    icon: <Calendar className="w-6 h-6 text-white" data-id="element-263" />,
    title: 'El Plan de Acción de 7 Días',
    desc: 'Implementación inmediata',
    result: 'Resultados desde el primer día'
  }, {
    icon: <HelpCircle className="w-6 h-6 text-white" data-id="element-264" />,
    title: 'FAQ de Crisis',
    desc: 'Respuestas a las 8 situaciones más difíciles',
    result: 'Nunca más te quedas sin saber qué hacer'
  }, {
    icon: <Book className="w-6 h-6 text-white" data-id="element-265" />,
    title: 'Glosario de Crianza Digital',
    desc: 'Términos clave explicados',
    result: 'Entiendes el cerebro de tu hijo como nunca antes'
  }];
  return <section className="w-full py-24 px-6 bg-charcoal text-white relative" data-id="element-266">
      {/* Top wave separator */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none rotate-180" data-id="element-267">
        <svg className="relative block w-full h-[40px] md:h-[60px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-268">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C59.71,118.08,130.83,119.93,197.36,97.7,243.9,82.22,285.34,63.11,321.39,56.44Z" className="fill-white" data-id="element-269"></path>
        </svg>
      </div>

      <div className="max-w-5xl mx-auto pt-10" data-id="element-270">
        <FadeIn data-id="element-271">
          <div className="text-center mb-16" data-id="element-272">
            <span className="text-terracotta-light font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-273">
              Presentamos
            </span>
            <h2 className="text-4xl md:text-6xl font-bold font-serif mb-6 text-cream" data-id="element-274">
              Plan "Cero Gritos" Post-Pantalla
            </h2>
            <p className="text-2xl md:text-3xl text-terracotta-light font-serif italic mb-8" data-id="element-275">
              El Método de la Rampa de Salida Emocional
            </p>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-276">
              Un sistema paso a paso, basado en neurociencia aplicada a la
              crianza, para que puedas apagar cualquier pantalla — sin gritos,
              sin guerras, sin culpa.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-277">
          <div className="text-center mb-12" data-id="element-278">
            <h3 className="text-2xl font-bold text-cream inline-flex items-center gap-3" data-id="element-279">
              <span className="bg-terracotta p-2 rounded-lg" data-id="element-280">🧩</span> ¿QUÉ
              INCLUYE?
            </h3>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-281">
          {modules.map((mod, index) => <FadeIn key={index} delay={0.1 * index} direction="up" data-id="element-282">
              <div className="bg-charcoal-light/50 border border-gray-700 p-6 rounded-2xl hover:border-terracotta/50 transition-colors h-full flex flex-col" data-id="element-283">
                <div className="flex items-start gap-4 mb-4" data-id="element-284">
                  <div className="bg-terracotta p-3 rounded-xl shrink-0" data-id="element-285">
                    {mod.icon}
                  </div>
                  <div data-id="element-286">
                    <h4 className="text-xl font-bold text-cream mb-1" data-id="element-287">
                      {mod.title}
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-288">{mod.desc}</p>
                  </div>
                </div>
                <div className="mt-auto pt-4 border-t border-gray-700" data-id="element-289">
                  <p className="text-sage-light font-medium flex items-center gap-2" data-id="element-290">
                    <span className="text-lg" data-id="element-291">💡</span> {mod.result}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}